module.exports = __webpack_public_path__ + "img/logo-big.6717a0ed.svg";